import { resetAllStores } from "../state/resetAllStores";
import { clearAllSessionStorage, clearPersistenceStorage } from "./navigation/persistenceKeys";
import { clearRememberedNavigation } from "./navigation/rememberedNavigationPersistence";
import { clearRememberedRoutesForContextReset } from "./navigation/sectionHistory";

/** The single cleanup boundary for sign-in, sign-out, and account-context changes. */
export function clearAuthenticationClientState() {
  resetAllStores();
  clearAllSessionStorage(sessionStorage);
  clearRememberedNavigation();
}

export function clearAccountContextClientState() {
  resetAllStores();
  clearPersistenceStorage(sessionStorage);
  clearRememberedRoutesForContextReset();
}
